/** Default number of results shown per page in the results table. */
export const SEARCH_PAGE_SIZE = 10;
